import * as React from 'react';
import { getButtonTextByReferrer } from './getButtonTextByReferrer';
import { IBackToPageContainerContextProps } from '../types';

export const useButtonProps = ({ backBtnTexts }: IBackToPageContainerContextProps) => {
  const [text, setButtonText] = React.useState<string | null>(null);
  const [href, setHref] = React.useState<string | null>(null);

  React.useEffect(() => {
    let { referrer } = document;

    /**
     * При прямом заходе в форму
     * устанавливаем на кнопку "Назад" ссылку на главную cian (с учетом поддомена)
     * */
    if (!referrer) {
      referrer = location.origin;
    }

    setHref(referrer);
    setButtonText(getButtonTextByReferrer({ referrer, backBtnTexts }));
  }, [backBtnTexts]);

  return { href, text };
};
